<script>
export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        setActive: {
            type: [String, Boolean],
            default: undefined,
            required: false,
        },
        courseInfo: {
            type: Object,
            default: () => ({}),
            required: false,
        },
    },
    computed: {
        active() {
            const overlays = this.$store.getters["skyOverlay/overlays"];
            if (this.name in overlays) {
                return overlays[this.name].active;
            }
            return false;
        },
    },
    methods: {
        toggleOverlay() {
            const payload = {
                name: this.name,
                active: undefined,
            };

            if (this.setActive !== undefined) {
                if (typeof this.setActive === "boolean") {
                    payload.active = this.setActive;
                } else {
                    payload.active = this.setActive === "true";
                }
            }

            this.$store.dispatch("skyOverlay/toggle", payload);

            if (this.courseInfo !== undefined) {
                // this.$store.dispatch(
                //     "skyOverlay/setCourseInfo",
                //     this.courseInfo
                // );
                this.$store.commit("skyOverlay/setCourseInfo", this.courseInfo);
            }
        },
    },
};
</script>

<template src="./sky-overlay-toggle.html"></template>



// WEBPACK FOOTER //
// sky-overlay-toggle.vue?6a69a42f